import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Success.css';

const Success = () => {
  // Clear cart on successful purchase
  useEffect(() => {
    localStorage.removeItem('cartItems');
  }, []);

  return (
    <div className="success-page">
      <div className="success-container">
        <div className="success-icon">
          <i className="fas fa-check-circle"></i>
        </div>
        <h1>Payment Successful!</h1>
        <p>Thank you for your purchase from Black Cat Ghost Hunting.</p>
        <p>Your order has been processed successfully and you will receive a confirmation email shortly.</p>
        <div className="success-actions">
          <Link to="/" className="home-btn">Return to Home</Link>
          <Link to="/merch" className="shop-btn">Continue Shopping</Link>
        </div>
      </div>
    </div>
  );
};

export default Success;
